export default "__VITE_ASSET__Dg6q4t$X__"